import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="border-b-4 border-b-blue-300 flex items-center justify-between">
      <h1 className="text-3xl font-bold ml-8  py-4 text-blue-300">
        <Link to="/">Le Calculoscope</Link>
      </h1>
      <Link
        className="mr-16 font-bold text-blue-300 hover:text-blue-700"
        to="/"
      >
        Accueil{" "}
      </Link>
    </header>
  );
};

export default Header;
